import _ from 'lodash';

function apply(source, dest) {
	source.instructions = dest.instructions;
	Object.keys(source.variables).map(key => {
		source.variables[key] = dest.variables[key];
	});
	Object.keys(source.tools).map(toolName => {
		let tool = source.tools[toolName];
		let editingTool = dest.tools[toolName];
		if (tool.respones) {
			Object.keys(tool.responses).map(key => {
				tool.responses[key] = editingTool[toolName].responses[key];
			});
		}
		tool.definition.description = editingTool.definition.description;
		Object.keys(tool.definition.parameters.properties).map(propName => {
			tool.definition.parameters.properties[propName].description = editingTool.definition.parameters.properties[propName].description;
		});
	});
}

export {
	apply
}

export default {
    data() {
        function formatName(n) { 
            return (n || '').replace(/[\-\– \.\,\\+\'\-\"®@]/g, '');
        }
    
        function getProduct(menu, category, product) {
            let item = menu?.find(f => formatName(f.FullPath === category) && formatName(f.name === product));
    
            if (!item) {
                item = menu?.find(f => formatName(f.name) === formatName(product));
            }
    
            return item;
        }

        return {
            aiConfig: {
				instructions: `You are a salesperson at '[companyName]'.\r\n` +
					`You have a menu at your disposal consisting of categories and product items. Your task is to help the customer place an order.\r\n` +
					`Your primary language is [language]. But you can switch to any other.\r\n` +
					`Be friendly and concise. Your goal is to form an order based on the customer's request and call the appropriate function.\r\n` +
					`First, greet the customer and ask how you can assist and ` +
					`immediately call get_menu for the actual menu and get_all_ingredients to retrieve the full list of ingredients.\r\n` +
					`Don't list every available product each time, but if you think it's necessary, ask the visitor if they would like you to list the available options.\r\n` +
					`Use related tools: show_products or show_category to navigate user to some products or categories. Don't use them each time, but only if you suggesting some products.\r\n` +
					`If user selected product call tool select_product.\r\n` +
					`If the customer ordered multiple products and you've finished processing them, ask if they need anything else. If not, and the customer is ready to complete the order, call the finish_order tool.\r\n` +
					`All function calls with products, ingredients, categories names should be made with it's original menu name, not translated or changed.\r\n` + 
					`When you finish the order, make sure to call the finish_order tool for 100% of orders.\r\n` +
					`Never call finish_order on your own or without reason. You must have explicit verbal confirmation from the customer that they are ready to complete the order.\r\n` +
					`Use only products that available in menu. If prodived menu language is different - translate it.`,
				variables: {
					companyName: '',
					language: navigator?.language || 'en-US',
					evaluate: (vars) => {
						if (__DEBUG__)
							console.debug('Evaluate', { vars, sc: this.selectedCompany });

						vars.companyName = this.selectedCompany?.name || '';

						if (!this.isDebug || !vars.language) {
							vars.language = navigator?.language || 'en-US';
						}
					}
				},
				tools: {
					change_language: {
						handler: async ({ languageCode }, options, tool, dc) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('change_language', { languageCode });
                            }

							const event = {
								type: "session.update",
								session: {
									input_audio_transcription: {
										model: "whisper-1",
										language: languageCode
									}
								}
							};

							dc.send(JSON.stringify(event));
                    
                            return `language changed to ${languageCode}`;
						},
						definition: {
							"type": "function",
							"name": "change_language",
							"description": "Called when user changing speaking language",
							"parameters": {
							"type": "object",
							"properties": {
								"languageCode": {
									"type": "string",
									"description": "Should be language code, for example: en, ru, es, nl, etc."
								}
							},
							"required": ["languageCode"]
							}
						},
					},
					show_category: {
                        responses: {
                            categoryShown: "If the order is visible, hide it to improve customer navigation."
                        },
						handler: async ({ category }, options, tool) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('show_category', { category });
                            }
                    
                            return tool.responses.categoryShown;
						},
						definition: {
							"type": "function",
							"name": "show_category",
							"description": "Displays a specific category to the client in the UI.",
							"parameters": {
							"type": "object",
							"properties": {
								"category": {
									"type": "string",
									"description": "Category name to show"
								}
							},
							"required": ["category"]
							}
						},
					},
					show_products: {
						handler: async ({ products }, options) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('show_products', { productNames: (products || '').split('|').filter(f => f) });
                            }
                    
                            return "products shown";
						},
						definition: {
							"type": "function",
							"name": "show_products",
							"description": "Displays specific products to the client in the UI.",
							"parameters": {
								"type": "object",
								"properties": {
									"products": {
										"type": "string",
										"description": "Array of product names to show separated by |"
									}
								},
								"required": ["products"]
							}
						},

					},
					get_sizes: {
						handler: async ({ category, product }, options) => {
                            let item = getProduct(options.menu, category, product);

                            if (options?.onToolExecution) {
                                options.onToolExecution('get_sizes', { category, product });
                            }

                            if (item?.sizes?.length) {
                                return item.sizes.map(f => f.name);
                            }

                            return "no additional sizes available";
						},
						definition: {
							"type": "function",
							"name": "get_sizes",
							"description": "Returns sizes (if the product has any additional ones).",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									}
								},
								"required": ["category", "product"]
							}
						},
					},
					get_extras: {
						handler: async ({ category, product }, options) => {
                            let item = getProduct(options.menu, category, product);

                            if (options?.onToolExecution) {
                                options.onToolExecution('get_extras', { category, product });
                            }

                            if (item?.extras?.length) {
                                return item.extras.map(f => f.name);
                            }

                            return "no additional extras available";
						},
						definition: {
							"type": "function",
							"name": "get_extras",
							"description": "Returns extras (if the product has any).",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									}
								},
								"required": ["category", "product"]
							}
						},
					},
					select_size: {
                        responses: {
                            hasExtras: "This product has extras. It shown in UI. Ask the user to choose from the available extras using the get_extras tool and wait response.",
							processed: "Extras have been selected. Call the finish_sizes_and_extras_processing tool, then ask the user if they want anything else or if they are done ordering.",
                        },
						handler: async ({ category, product, size }, options, tool) => {
                            let item = getProduct(options.menu, category, product);

                            if (options?.onToolExecution) {
                                options.onToolExecution('select_size', { category, product, size });
                            }

                            if (item?.extras?.length) {
                                return tool.responses.hasExtras;
                            }

                            return tool.responses.processed;
						},
						definition: {
							"type": "function",
							"name": "select_size",
							"description": "Called when the user selects a specific size for a product.",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									},
									"size": {
										"type": "string",
										"description": "Size name"
									}
								},
								"required": ["category", "product", "size"]
							}
						},
					},
					select_extras: {
                        responses: {
                            selected: "Ask the user if they want to add more extras. If not, call the finish_sizes_and_extras_processing tool, then ask if they want anything else or if they are done ordering."
                        },
						handler: async ({ category, product, extras }, options, tool) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('select_extras', { category, product, extras: (extras || '').split('|').filter(f => f) });
                            }
                    
                            return tool.responses.selected;
						},
						definition: {
							"type": "function",
							"name": "select_extras",
							"description": "Called when the user selects specific extras for a product.",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									},
									"extras": {
										"type": "string",
										"description": "Extras name separated with |"
									}
								},
								"required": ["category", "product", "extras"]
							}
						},
					},
					select_product: {
                        responses: {
                            hasSizes: "Product has additional sizes choice. It shown in UI. Ask the user to select from the available sizes using the get_sizes tool.",
                            hasExtras: "This product has extras. It shown in UI. Ask the user to choose from the available extras using the get_extras tool and wait response."
                        },
						handler: async ({ category, product, quantity }, options, tool) => {
                            let item = getProduct(options.menu, category, product);

                            if (item && options?.onToolExecution) {
                                options.onToolExecution('select_product', { category, product, quantity });
                            }

                            if (item?.sizes?.length) {
                                return tool.responses.hasSizes;
                            }

                            if (item?.extras?.length) {
                                return tool.responses.hasExtras;
                            }

                            return "product selected";
						},
						definition: {
							"type": "function",
							"name": "select_product",
							"description": "Call this function every time a product needs to be added to the order.",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									},
									"quantity": {
										"type": "number",
										"description": "Quantity"
									}
								},
								"required": ["category", "product", "quantity"]
							}
						},
					},
					finish_sizes_and_extras_processing: {
                        responses: {
                            instructions: "Order with processed product is shown. State the total amount of the order. Ask the customer if they'd like to add more products, then display the order using the show_order tool. " +
                                "If they don’t wish to add any further items and are ready to complete their order, call the finish_order tool. "
                        },
						handler: async (data, options, tool) => {
                            if (options?.onToolExecution) {
                                await options.onToolExecution('finish_sizes_and_extras_processing');
                            }
                    
                            return tool.responses.instructions;
						},
						definition: {
							"type": "function",
							"name": "finish_sizes_and_extras_processing",
							"description": "Called only when a product has sizes or extras and the selection is complete.",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									}
								},
								"required": ["category", "product"]
							}
						},
					},
					finish_order: {
                        responses: {
                            instructions: `Make sure to inform about the total amount of their current order, which is [orderTotal], currency is [orderCurrency]. ` +
                                `The order has been completed. Then thank the customer for placing the order and switch to waiting mode for a new customer and a new order. Start the next order from scratch—the product list has been cleared.`
                        },
						handler: async (data, options, tool) => {
                            let orderInfo = {};
                            if (options?.onToolExecution) {
                                orderInfo = await options.onToolExecution('finish_order');
                            }
                            
                            return tool.responses.instructions
                                .replace(/\[orderTotal\]/g, orderInfo.total)
                                .replace(/\[orderCurrency\]/g, orderInfo.currency);
						},
						definition: {
							"type": "function",
							"name": "finish_order",
							"description": "When you finish the order, make sure to call the finish_order tool for 100% of orders.",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					},
					show_order: {
						handler: async ({ visible }, options) => {
                            if (options?.onToolExecution) {
                                await options.onToolExecution('show_order', { visible });
                            }
                    
                            return `Order shown`;
						},
						definition: {
							"type": "function",
							"name": "show_order",
							"description": "Call when the current order needs to be shown to the customer.",
							"parameters": {
								"type": "object",
								"properties": {
									"visible": {
										"type": "boolean",
										"description": "True when the order needs to be shown, False when it needs to be hidden."
									},
								},
								"required": []
							}
						},
					},
					continue_ordering: {
						handler: async (data, options) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('continue_ordering');
                            }
                    
                            return "executed";
						},
						definition: {
							"type": "function",
							"name": "continue_ordering",
							"description": "Call when the customer decides to continue ordering.",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					},
					get_order_positions: {
						handler: async (data, options) => {
                            if (options?.onToolExecution) {
                                return await options.onToolExecution('get_order_positions');
                            }
                    
                            return "no items available";
						},
						definition: {
							"type": "function",
							"name": "get_order_positions",
							"description": "Returns the current items in the order with their quantities.Call when the customer decides to continue ordering. Always use when the user requests any action with the order (add something, remove, change quantity).",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					},
					change_order_position: {
						handler: async ({ positionIndex, quantity }, options) => {
                            if (options?.onToolExecution) {
                                options.onToolExecution('change_order_position', { positionIndex, quantity });
                            }
                    
                            return "order updated";
						},
						definition: {
							"type": "function",
							"name": "change_order_position",
							"description": "Called every time the customer wants to modify the order: remove an item or change the quantity.",
							"parameters": {
								"type": "object",
								"properties": {
									"positionIndex": {
										"type": "number",
										"description": "Position index in the order starts from 0."
									},
									"quantity": {
										"type": "number",
										"description": "New quantity. Set to 0 if the item needs to be removed."
									},
								},
								"required": ["positionIndex", "quantity"]
							}
						},
					},
					get_all_ingredients: {
						handler: async (data, options) => {
                            if (options?.onToolExecution) {
                                return await options.onToolExecution('get_all_ingredients', { });
                            }
                    
                            return "no ingredients available";
						},
						definition: {
							"type": "function",
							"name": "get_all_ingredients",
							"description": "Returns the full list of available ingredients in the menu. When using these names in other tools do not translate it and use only existing ingredients.",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					},
					get_product_ingredients: {
						handler: async ({ category, product }, options) => {
                            let item = getProduct(options.menu, category, product);

                            if (options?.onToolExecution) {
                                options.onToolExecution('select_size', { category, product });
                            }

                            if (item.ingredients?.length) {
                                return item.ingredients;
                            }
                            
                            return "no ingredients available";
						},
						definition: {
							"type": "function",
							"name": "get_product_ingredients",
							"description": "Returns the list of ingredients for a specific product.",
							"parameters": {
								"type": "object",
								"properties": {
									"category": {
										"type": "string",
										"description": "Product category"
									},
									"product": {
										"type": "string",
										"description": "Product name"
									}
								},
								"required": ["category", "product"]
							}
						},
					},
					filter_products_by_ingredients: {
						handler: async ({ included, excluded, includedCategories, excludedCategories }, options) => {
                            if (options?.onToolExecution) {
                                return await options.onToolExecution('filter_products_by_ingredients', {
                                    included: (included || '').split('|').filter(f => f), 
                                    excluded: (excluded || '').split('|').filter(f => f),
                                    includedCategories: (includedCategories || '').split('|').filter(f => f), 
                                    excludedCategories: (excludedCategories || '').split('|').filter(f => f), 
                                });
                            }
                    
                            return "no products available";
						},
						definition: {
							"type": "function",
							"name": "filter_products_by_ingredients",
							"description": "Returns the list of products based on the provided ingredients. Use the include and exclude properties to fulfill the customer's request.",
							"parameters": {
								"type": "object",
								"properties": {
									"included": {
										"type": "string",
										"description": "A list of ingredients, separated by |, that the product must contain."
									},
									"excluded": {
										"type": "string",
										"description": "A list of ingredients, separated by |, that the product must not contain."
									},
									"includedCategories": {
										"type": "string",
										"description": "A list of categories, separated by |, to be included in the search."
									},
									"excludedCategories": {
										"type": "string",
										"description": "A list of categories, separated by |, to be excluded in the search."
									},
								},
								"required": ["included", "excluded"]
							}
						},
					},
					cancel: {
						handler: async (data, options) => {
                            if (options?.onToolExecution) {
                                return await options.onToolExecution('cancel');
                            }
                    
                            return "cancel action executed";
						},
						definition: {
							"type": "function",
							"name": "cancel",
							"description": "Use this function to reset the current UI state to its initial state.",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					},
					get_menu: {
						handler: async (data, options) => {
							let menu = options.menu;

							let categories = _.groupBy(menu, f => [f.productCategory?.ParentCategory?.Name, f.productCategory?.Name].filter(c => c).join('\\'));
							let result = Object.keys(categories).map(f => {
								let items = categories[f].map(i => ` - ${i.name}`).join('\r\n');
								return `Category "${f}" products: \r\n${items}`;
							}).join('\r\n\r\n');

							if (__DEBUG__)
								console.debug('MakeMenu', { result });

							return result;
						},
						definition: {
							"type": "function",
							"name": "get_menu",
							"description": "Use this function to get menu.",
							"parameters": {
								"type": "object",
								"properties": {
								},
								"required": []
							}
						},
					}
				}
			}
        }
    },
	mounted() {
		this.$defAiConfig = JSON.parse(JSON.stringify(this.aiConfig));
	},
	unmounted() {
		delete this.$defAiConfig;
	}
}